import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getFullSeasonStats } from '../actions/reportsActions';
import { getSeasonDivisions } from '../actions/divisionsActions';
import WheelReport from '../components/WheelReport';

const mapDispatchToProps = dispatch => {
  return {
    getFullSeasonStats: parentSeasonId => {
      dispatch(getFullSeasonStats(parentSeasonId));
    },
    getSeasonDivisions: seasonId => {
      dispatch(getSeasonDivisions(seasonId));
    }
  };
};

const mapStateToProps = state => ({
  statsSeasons: state.reports.statsSeasons,
  statsSeasonsList: state.reports.statsSeasonsList,
  umpiresStats: state.reports.umpiresStats,
  umpiresStatsList: state.reports.umpiresStatsList,
  fetchingFullSeasonStatsStatus: state.reports.fetchingFullSeasonStatsStatus,
  seasons: state.seasons.seasons,
  seasonDivisions: state.divisions.seasonDivisions,
  seasonDivisionsList: state.divisions.seasonDivisionsList,
  fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
  userSeason: state.user.userSeason
});

const WheelReportContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(WheelReport));
export default WheelReportContainer;



// WEBPACK FOOTER //
// ./src/containers/WheelReportContainer.js